module.exports = __webpack_public_path__ + "img/leftcode.6ddbb6cb.png";